export function getUniqueInteger(str: string): number {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    hash += charCode;
  }

  return hash % 17;
}

export const COVER_PATTERNS = [
  'https://res.cloudinary.com/geerd/image/upload/v1688462289/easyclass/patterns/Taieri_wqowji.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462289/easyclass/patterns/Rho_%C3%A9ne_eaye48.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462289/easyclass/patterns/Reuss_p8ypmb.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462288/easyclass/patterns/Rangitikei_mvmfxz.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462287/easyclass/patterns/Oreti_vdd7mn.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462287/easyclass/patterns/Inn_q4qpe9.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462287/easyclass/patterns/Hinterrhein_ajnc9m.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462288/easyclass/patterns/Ngaruroro_pkguyg.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462288/easyclass/patterns/Waimakariri_m0mep1.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462286/easyclass/patterns/Mataura_iv7pkq.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462286/easyclass/patterns/Kander_t8qhhn.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462286/easyclass/patterns/Aare_ctlh1g.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462286/easyclass/patterns/Mohaka_fzhhht.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462286/easyclass/patterns/Doubs_zwnoq9.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462284/easyclass/patterns/Waiau_vcuam2.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462284/easyclass/patterns/Clarence_h8fzcv.svg',
  'https://res.cloudinary.com/geerd/image/upload/v1688462284/easyclass/patterns/Linth_mrdp5k.svg',
];
